import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
  Address,
  IAktionen,
  IBusinessData,
  IConfirmationStatus,
  IContractDetails,
  IdCard,
  IERechnungsInfo,
  INewClientTrackingData,
  IOlavEntry,
  IOrderDetailsInfo,
  IOrganisation,
  IPersonalData,
  IProduktAuswahl,
  IProduktSelektion,
  IProduktVerfuegbarkeit,
  IUploadResult,
  IVertragskonto,
  NewClientContractDetailsViewModel,
  OrderIPDFLinks,
  PreisIndikation,
  Product,
} from '@mwe/models';
import { BehaviorSubject } from 'rxjs';
import { ProductCategoryEnum, ServiceStateEnum } from '@mwe/constants';
import { withStorageServiceFeature } from '../../store-features/storage-service.feature';
import { withAuthenticationStateFeature } from '../../store-features/authentication.feature';

const initialState = {
  tempProductSelectionForVoucher: null as IProduktSelektion,
  newClientProfileChecked: null as boolean,
  newProductAvailabilitiesSuccessStateSubject: null as BehaviorSubject<true>,
  submitSuccessStateSubject: null as BehaviorSubject<ServiceStateEnum.INIT>,
  newClientMgmCode: null as string,
  newClientAddress: null as Address,
  newClientAddressOlav: null as IOlavEntry,
  invoiceAddressOlav: null as IOlavEntry,
  newProductAvailabilities: null as IProduktVerfuegbarkeit[],
  newProductAvailabilitiesState: null as ServiceStateEnum,
  predefinedProductsForSelection: null as IProduktAuswahl,
  productsForSelection: null as IProduktAuswahl,
  productSelection: null as IProduktSelektion,
  selectedPriceIndications: null as PreisIndikation[],
  registrationDate: null as string,
  orderDetails: null as IOrderDetailsInfo[],
  personalData: null as IPersonalData,
  personalBusinessData: null as IBusinessData,
  organisationData: null as IOrganisation,
  invoiceData: null as IVertragskonto,
  idCard: null as IdCard,
  uploadedFiles: null as IUploadResult,
  pdfLinks: null as OrderIPDFLinks,
  contractDetails: null as IContractDetails,
  contractDetailsViewModel: null as NewClientContractDetailsViewModel,
  eRechnungsInfo: null as IERechnungsInfo,
  notLoggedIn: null as string,
  lastOrderDate: null as string,
  orderSuccessfull: null as boolean,
  submitSuccessState: null as ServiceStateEnum,
  voucherInfo: null as IAktionen,
  predefinedVoucherCode: null as string,
  autoRegistrationSuccessful: null as boolean,
  preselectProductFernwaerme: null as boolean,
  trackingData: null as INewClientTrackingData,
  sendProductInterestState: null as ServiceStateEnum,
  hasPriceIndicationsReloadError: null as boolean,
  grantedMarketingPermission: null as boolean,
  tkConnId: null as string,
  skipPreselectedAddress: null as boolean,
  predefinedOlavKey: null as string,
  confirmationStatus: null as IConfirmationStatus,
  previousSelectedProductCategories: [] as ProductCategoryEnum[],
  productsToShow: [] as Product[],
  predefinedProducts: [] as Product[],
  selectedProducts: [] as Product[],
  primaryCategorySelected: {} as Record<string, boolean>,
};

type InitialNewClientState = typeof initialState;

export const NewClientStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withAuthenticationStateFeature(),
  withStorageServiceFeature('new-client'),
  withMethods(store => {
    const updateStoreState = (storeStateValues: Partial<InitialNewClientState>) => {
      patchState(store, { ...storeStateValues });
    };

    return {
      updateStoreState,
    };
  }),
);
